module.exports = __webpack_public_path__ + "static/media/logo-verticality.7a7344cb.svg";